var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAirportGate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.99 9.924a1.16 1.16 0 0 1-.132.892 1.18 1.18 0 0 1-.721.55l-7.63 2.05-4.194 1.1-1.252.38-2.088-3.549 1.158-.303 1.556 1.176 3.929-1.024L5.35 5.52l1.519-.417 5.446 5.086 4.232-1.12q.475-.132.902.123.427.257.54.731z"
})));
export default SvgAirportGate;